import { useMsal } from "@azure/msal-react";
import { Button } from "../Button/Button";
import styles from "./HeadLog.module.scss";
import { loginRequest } from "../../authConfig";
import { isPWAInstalled } from "../../utils";
import { setShowAccessKey } from "../../features/counter/counterSlice";
import { useDispatch, useSelector } from "react-redux";
import { openLoginModal } from "../../features/search/util";
import useAppModernisation from "../../hooks/useAppModernisation";
import AccessKeyModal from "../AccessKeyModal/AccessKeyModal";

export const HeadLog = () => {
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const { isAppMode } = useAppModernisation();
  const showAccessKey = useSelector((state) => state.counter.showAccessKey);

  const handleLoginClick = async () => {
    if (isPWAInstalled()) {
      localStorage.removeItem("lastVisited");
      instance.loginRedirect(loginRequest).catch((e) => {
        console.error(e);
      });
    } else {
      const response = await instance.loginPopup(loginRequest);
      console.log("Login response:", response);
      window.location.reload();
    }
  };

  const handleAccessToken = () => {
    dispatch(setShowAccessKey(true));
    localStorage.removeItem("lastVisited");
    // legacy modal
    if (!isAppMode) {
      openLoginModal();
    }
  };

  const handleCloseAccessKeyModal = () => {
    dispatch(setShowAccessKey(false));
  };

  return (
    <>
      <div className={`container ${styles.container}`}>
        {!isAppMode && <Button bgColor="black">Subscribe</Button>}
        <Button bgColor="black" onClick={handleLoginClick}>
          Log in
        </Button>
        {isAppMode && <Button onClick={handleAccessToken}>Access key</Button>}
      </div>

      {isAppMode && (
        <AccessKeyModal
          isOpen={showAccessKey}
          onClose={handleCloseAccessKeyModal}
        />
      )}
    </>
  );
};
